'use strict';

import extend from 'lodash/extend';

/**
 * Low-level communication handler that reads configuration.
 * Uses Q-based promises for all operations.
 */
/* global jQuery */
(function ($) {
  window.atex = window.atex || {};
  window.atex.aceui = window.atex.aceui || {};
  window.atex.aceui.service = window.atex.aceui.service || {};

  /**
   * Creates a new ConfigurationService object.
   *
   * Argument 'configurationUrl' - The URL to the configuration JSON.
   * Argument 'serviceSettings' - An object containing settings for this service.
   *
   * The 'serviceSettings' object should look like the following:
   *
   * {
   *   customQ: customQObject
   * }
   *
   * Property 'customQ' is an implementation of a promise library,
   * i.e Angular $q. Defaults to a global Q.
   *
   * Returns a new ConfigurationService object.
   */
  atex.aceui.service.ConfigurationService = function (configurationUrl, serviceSettings) {
    var settings = extend({}, serviceSettings);
    var q = settings.customQ || window.Q;

    return {
      /**
       * Reads JSON configuration from the server using the configuration URL
       * given in the service settings object.
       *
       * Returns a Q-based promise.
       *
       * If the operation succeeds the returned promise is resolved with the
       * JSON configuration as a JavaScript object.
       *
       * Rejects the return promise with an atex.aceui.error.Error object if the operation fails.
       */
      readConfiguration: function () {
        var deferred = q.defer();

        $.ajax(configurationUrl, {
          dataType: 'json',

          success: function (data) {
            deferred.resolve(data);
          },

          error: function (jqXHR, textStatus, errorThrown) {
            var e = atex.aceui.HTTPUtils.createError(jqXHR, 'atex.aceui.service.ConfigurationService', {
              'default': 'Error while reading configuration from server!'
            });

            if (typeof e.rootCause !== 'undefined') {
              e.rootCause.textStatus = textStatus;
              e.rootCause.errorThrown = errorThrown;
            }

            deferred.reject(e);
          }
        });

        return deferred.promise;
      }
    };
  };
})(jQuery);
